const MAILING_UNSUBSCRIBE_FUNCTION_URL =
  'https://us-central1-clube-42-3baa5.cloudfunctions.net/onMailingUnsubscribeRequest';

export interface MailingUnsubscribeRequestPayload {
  email: string;
  name?: string;
  source: string;
  pageUrl?: string;
}

export const saveMailingUnsubscribeRequest = async (
  data: MailingUnsubscribeRequestPayload,
): Promise<void> => {
  const payload = {
    email: data.email.trim().toLowerCase(),
    name: data.name?.trim() || undefined,
    source: data.source,
    pageUrl: data.pageUrl ?? window.location.pathname,
  };

  const response = await fetch(MAILING_UNSUBSCRIBE_FUNCTION_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.error ||
        errorData.message ||
        `Erro na requisição: ${response.status}`,
    );
  }
};
